export const LOCALES_WITH_WARRANTY_EXCLUSION = ['fr-fr', 'fr-be']
